const dateRangeLabels = [
	{
		id: "PreviousWeek",
		title: "Previous Week",
		dynamicValue: true,
		showWeekStart: true
	},
	{
		id: "CurrentWeek",
		title: "Current Week",
		dynamicValue: true,
		showWeekStart: true
	},
	{
		id: "NextWeek",
		title: "Next Week",
		dynamicValue: true,
		showWeekStart: true
	},
	{
		id: "CurrentMonth",
		title: "Current Month",
		dynamicValue: true,
		showWeekStart: false
	},
	{
		id: "CurrentQuarter",
		title: "Current Quarter",
		dynamicValue: true,
		showWeekStart: false
	}
]

const dateRangeRangeLabels = [
	{
		id: "CurrentWeek",
		title: "Current Week"
	},
	{
		id: "CurrentMonth",
		title: "Current Month"
	},
	{
		id: "WeekNumber",
		title: "Week Number"
	},
	{
		id: "MonthRange",
		title: "Month Range"
	},
	{
		id: "YearToDate",
		title: "Year to Date"
	},
	{
		id: "DateRange",
		title: "Date Range"
	}
]

export { dateRangeLabels, dateRangeRangeLabels }
